import React, { useContext, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Link, useHistory } from "react-router-dom";

import FormContext from "../context/FormContext";
import { Container } from "react-bootstrap";

import Styles from "../styles.module.scss";
import { FormType, ModeType } from "../types/Types";

export const SecondForm: () => JSX.Element = () => {
  const history = useHistory();
  const { formData, setFormData } = useContext(FormContext);

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch
  } = useForm();

  const showTime = watch("projectTime");
  const techs = watch("projectTechs");

  useEffect(() => {
    if (!formData?.projectName) {
      history.push("/example/forms-challenge/");
    }
  }, [formData]);

  const submitVoid = (data: FormType) => {
    if (!errors.length) {
      setFormData({ ...formData, ...data });
      history.push("/example/forms-challenge/third");
    }
  };

  const timePerWork = (mode: ModeType) => {
    if (mode === "High") {
      return 3500;
    } else {
      if (mode === "Medium") {
        return 2600;
      } else {
        return 1000;
      }
    }
  };

  return (
    <Container className={Styles.mainContainer}>
      <Link to={"/example/forms-challenge"}>Volver</Link>

      <form onSubmit={handleSubmit(submitVoid)}>
        <p className='mt-3 font-weight-bold'>Seleccione un rango de tiempo</p>
        <div className={Styles.rangeDiv}>
          <input
            className='w-75'
            type='range'
            id='time'
            defaultValue={100}
            min={1}
            max={5000}
            {...register("projectTime", { required: true })}
          />
          <p>{showTime | 0} hora/s</p>
        </div>

        {showTime < timePerWork(formData?.projectLevel || "Low") ? (
          <p className={Styles.errorP}>
            Error, el tiempo debe mayor o igual a{" "}
            {timePerWork(formData?.projectLevel || "Low")} horas, debido a que
            usted seleccionó el nivel de importancia: {formData?.projectLevel}
          </p>
        ) : (
          ""
        )}

        <div className={Styles.miniContainer}>
          <p className='mt-3 font-weight-bold'>
            Tecnologias requeridas: (Seleccione 1 o más)
          </p>
          <label className='mt-3'>
            <input
              className='mr-1'
              type='checkbox'
              value='React'
              {...register("projectTechs", {})}
            />
            React
          </label>
          <label>
            <input
              className='mr-1'
              type='checkbox'
              value='Laravel'
              {...register("projectTechs", {})}
            />
            Laravel
          </label>
          <label>
            <input
              className='mr-1'
              type='checkbox'
              value='Wordpress'
              {...register("projectTechs", {})}
            />
            Wordpress
          </label>
        </div>

        {!techs || techs.length === 0 ? (
          <p className={Styles.errorP}>Seleccione al menos una opcion</p>
        ) : (
          " "
        )}

        <input
          type='submit'
          disabled={
            !techs ||
            techs.length === 0 ||
            showTime < timePerWork(formData?.projectLevel || "Low") ||
            showTime === undefined
              ? true
              : false
          }
          className={Styles.submitButton}
        />
      </form>
    </Container>
  );
};
